import React, { useState, useEffect } from 'react';

export default function GlobalLoader() {
  const [loading, setLoading] = useState(true);
  const [fading, setFading] = useState(false);

  useEffect(() => {
    // Start fading out after 1.2 seconds
    const fadeTimer = setTimeout(() => {
      setFading(true);
    }, 1200);

    // Completely remove from DOM after 1.8 seconds
    const removeTimer = setTimeout(() => {
      setLoading(false);
    }, 1800);

    return () => {
      clearTimeout(fadeTimer);
      clearTimeout(removeTimer);
    };
  }, []);

  if (!loading) return null;

  return (
    <div 
      className={`fixed inset-0 z-[9999] flex flex-col items-center justify-center bg-[#FFFDF9] transition-opacity duration-700 ease-in-out ${fading ? 'opacity-0' : 'opacity-100'}`}
    >
      <div className="flex flex-col items-center relative">
        {/* Subtle glowing background behind logo */}
        <div className="absolute inset-0 bg-[#D4AF37]/20 blur-3xl rounded-full scale-150 animate-pulse"></div>
        
        {/* Logo with pulsing animation */}
        <img 
          src="/logo.png" 
          alt="Satala Dermatech" 
          className="h-16 md:h-20 w-auto object-contain z-10 animate-pulse"
        />
        
        {/* Loading text with slide up fade */}
        <div className="mt-8 z-10 overflow-hidden">
          <p className="text-[#8C6208] text-sm tracking-[0.3em] uppercase font-bold animate-[slideUp_1s_ease-out_forwards]">
            Elevating Beauty
          </p>
        </div>

        {/* Custom keyframes injected inline for simplicity */}
        <style dangerouslySetInnerHTML={{__html: `
          @keyframes slideUp {
            from { opacity: 0; transform: translateY(20px); }
            to { opacity: 1; transform: translateY(0); }
          }
        `}} />
      </div>
    </div>
  );
}
